<template>
  <!-- Choose a Class -->
  <section class="choose-car-class-section common-padding">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="home-six-heading-section aos" data-aos="fade-up">
            <div
              class="home-six-title d-flex justify-content-center align-items-center"
            >
              <h2>Choose a Class</h2>
              <img src="@/assets/img/icons/title.svg" alt="" />
            </div>
            <p>
              Rutrum ante tempus mauris facilisi, leo faucibus, egestas
              diamlorem malesu, vitae mauris.
            </p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="car-class-carousel">
            <div class="car-class-slider owl-carousel owl-theme">
              <Carousel
                :wrap-around="true"
                :settings="settings"
                :breakpoints="breakpoints"
              >
                <Slide v-for="item in IndexSearchCar" :key="item.id">
                  <div class="car-class-item-block aos" data-aos="fade-up">
                    <div class="car-class-item">
                      <router-link to="categories">
                        <div class="car-class-list">
                          <div
                            class="car-class-title d-flex justify-content-between"
                          >
                            <h5>{{ item.title }}</h5>
                            <span>{{ item.text }}</span>
                          </div>
                          <img
                            :src="require(`@/assets/img/${item.image}`)"
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                      </router-link>
                    </div>
                  </div>
                </Slide>
                <template #addons> </template>
              </Carousel>

              <Carousel
                :wrap-around="true"
                :settings="settings"
                :breakpoints="breakpoints"
              >
                <Slide v-for="item in IndexSearchCar" :key="item.id">
                  <div class="car-class-item-block aos" data-aos="fade-up">
                    <div class="car-class-item">
                      <router-link to="categories">
                        <div class="car-class-list">
                          <div
                            class="car-class-title d-flex justify-content-between"
                          >
                            <h5>{{ item.title }}</h5>
                            <span>{{ item.text }}</span>
                          </div>
                          <img
                            :src="require(`@/assets/img/${item.image}`)"
                            class="img-fluid"
                            alt=""
                          />
                        </div>
                      </router-link>
                    </div>
                  </div>
                </Slide>
                <template #addons>
                  <Pagination />
                </template>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Choose a Class -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexSearch from "@/assets/json/indexSearch.json";
import IndexSearchCar from "@/assets/json/indexSearchCar.json";
export default {
  data() {
    return {
      IndexSearch: IndexSearch,
      IndexSearchCar: IndexSearchCar,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991 and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  mouted() {},
};
</script>
